export const TOUR_STEP_IDS = {
  // Academy Owner & Admin
  WELCOME: "tour-welcome",
  BUSINESS_OVERVIEW: "business-overview",
  MANAGEMENT_TOOLS: "management-tools",
  MANAGE_ORGANIZATION: "manage-organization",
  /** @deprecated Use MANAGE_ORGANIZATION */
  MANAGE_ACADEMY: "manage-organization",
  MANAGE_ACADEMY_SETTINGS: "manage-academy-settings",
  MANAGE_COURTS: "manage-courts",
  MANAGE_STAFF: "manage-staff",
  MANAGE_TERMS: "manage-terms",
  MANAGE_CAMPS: "manage-camps",
  MANAGE_LESSONS: "manage-lessons",
  MANAGE_BOOKINGS: "manage-bookings",
  MANAGE_PAYMENTS: "manage-payments",
  MANAGE_STUDENTS: "manage-students",
  SETUP_CHECKLIST: "setup-checklist",
  TODAYS_SCHEDULE: "todays-schedule",
  RECENT_ACTIVITY: "recent-activity",
  CLUB_BUSINESS_OVERVIEW: "club-business-overview",
  ACCOUNT_MENU: "account-menu",
  /** @deprecated Use ACCOUNT_MENU */
  SETTINGS: "account-menu",
  DASHBOARD_MODE_SWITCH: "dashboard-mode-switch",
  // Student
  STUDENT_STATS: "student-stats",
  STUDENT_NAV: "student-nav",
  STUDENT_BROWSE_LESSONS: "student-browse-lessons",
  STUDENT_CALENDAR: "student-calendar",
  STUDENT_BOOKINGS: "student-bookings",
  STUDENT_CREDITS: "student-credits",
  STUDENT_PAYMENTS: "student-payments",
  STUDENT_MY_STUDENTS: "student-my-students",
  // Camp management
  CAMPS_GUIDE: "camp-tour-guide",
  CAMPS_NEW_CAMP: "camp-tour-new-camp",
  CAMPS_LIST_TABS: "camp-tour-list-tabs",
  CAMPS_FILTERS: "camp-tour-filters",
  CAMPS_FORM_DRAWER: "camp-tour-form-drawer",
  CAMPS_FORM_DETAILS: "camp-tour-form-details",
  CAMPS_FORM_SCHEDULE: "camp-tour-form-schedule",
  CAMPS_FORM_TIMES: "camp-tour-form-times",
  CAMPS_FORM_PRICING: "camp-tour-form-pricing",
  CAMPS_FORM_RESOURCES: "camp-tour-form-resources",
  CAMPS_FORM_SUBMIT: "camp-tour-form-submit",
  BOOKINGS_TABS: "academy-bookings-tour-tabs",
  BOOKINGS_FILTERS: "academy-bookings-tour-filters",
  BOOKINGS_LIST: "academy-bookings-tour-list",
  BOOKINGS_WAITLIST: "academy-bookings-tour-waitlist",
  BOOKINGS_EOI_SCOPE: "academy-bookings-tour-eoi-scope",
  BOOKINGS_EOI_LIST: "academy-bookings-tour-eoi-list",
  BOOKINGS_PRIVATE_INTRO: "academy-bookings-tour-private-intro",
  BOOKINGS_PRIVATE_LIST: "academy-bookings-tour-private-list",
  // Term management
  TERMS_GUIDE: "term-tour-guide",
  TERMS_NEW_TERM: "term-tour-new-term",
  TERMS_LIST_TABS: "term-tour-list-tabs",
  TERMS_FILTERS: "term-tour-filters",
  TERMS_FORM_DRAWER: "term-tour-form-drawer",
  TERMS_FORM_DETAILS: "term-tour-form-details",
  TERMS_FORM_SCHEDULE: "term-tour-form-schedule",
  TERMS_FORM_COPY: "term-tour-form-copy",
  TERMS_FORM_SUBMIT: "term-tour-form-submit",
  TERMS_MANAGE_HEADER: "term-tour-manage-header",
  TERMS_MANAGE_ADD_LESSON: "term-tour-manage-add-lesson",
  TERMS_MANAGE_VIEWS: "term-tour-manage-views",
  TERMS_MANAGE_LESSONS: "term-tour-manage-lessons",
  TERMS_LESSON_FORM_DETAILS: "term-tour-lesson-form-details",
  TERMS_LESSON_FORM_SCHEDULE: "term-tour-lesson-form-schedule",
  TERMS_LESSON_FORM_PRICING: "term-tour-lesson-form-pricing",
  TERMS_LESSON_FORM_SUBMIT: "term-tour-lesson-form-submit",
  // Lesson session detail drawer (calendar / schedule)
  LESSON_SESSION_DRAWER: "lesson-session-tour-drawer",
  LESSON_SESSION_OVERVIEW: "lesson-session-tour-overview",
  LESSON_SESSION_COACHES: "lesson-session-tour-coaches",
  LESSON_SESSION_STUDENTS: "lesson-session-tour-students",
  LESSON_SESSION_ACTIONS: "lesson-session-tour-actions",
  // Academy setup page tours
  ACADEMY_PROFILE_GUIDE: "academy-profile-tour-guide",
  ACADEMY_PROFILE_TABS: "academy-profile-tour-tabs",
  ACADEMY_PROFILE_FORM: "academy-profile-tour-form",
  ACADEMY_PUBLIC_SITE_GUIDE: "academy-public-site-tour-guide",
  ACADEMY_PUBLIC_SITE_URL: "academy-public-site-tour-url",
  ACADEMY_PUBLIC_SITE_BRANDING: "academy-public-site-tour-branding",
  ACADEMY_PUBLIC_SITE_MEDIA: "academy-public-site-tour-media",
  ACADEMY_PUBLIC_SITE_DIRECTORY: "academy-public-site-tour-directory",
  ACADEMY_PUBLIC_SITE_SAVE: "academy-public-site-tour-save",
  ACADEMY_SPORTS_GUIDE: "academy-sports-tour-guide",
  ACADEMY_SPORTS_LIST: "academy-sports-tour-list",
  ACADEMY_SPORTS_SAVE: "academy-sports-tour-save",
  ORGANIZATION_SETTINGS_GUIDE: "organization-settings-tour-guide",
  ORGANIZATION_SETTINGS_TAB_BASIC: "organization-settings-tour-tab-basic",
  ORGANIZATION_SETTINGS_TAB_PUBLIC_SITE: "organization-settings-tour-tab-public-site",
  ORGANIZATION_SETTINGS_TAB_SPORTS: "organization-settings-tour-tab-sports",
  ORGANIZATION_SETTINGS_TAB_PLAYER_RATINGS: "organization-settings-tour-tab-player-ratings",
  ORGANIZATION_PLAYER_RATINGS_FORM: "organization-settings-tour-player-ratings-form",
  ACADEMY_COURTS_TABS: "academy-courts-tour-tabs",
  ACADEMY_LOCATIONS_NEW: "academy-locations-tour-new",
  ACADEMY_LOCATIONS_LIST: "academy-locations-tour-list",
  ACADEMY_COACHES_TABS: "academy-coaches-tour-tabs",
  ACADEMY_COACHES_NEW: "academy-coaches-tour-new",
  ACADEMY_COACHES_LIST: "academy-coaches-tour-list",
  COACH_FORM_DRAWER: "coach-tour-form-drawer",
  COACH_FORM_CONTACT: "coach-tour-form-contact",
  COACH_FORM_COMPENSATION: "coach-tour-form-compensation",
  COACH_FORM_PROFILE: "coach-tour-form-profile",
  COACH_FORM_SUBMIT: "coach-tour-form-submit",
  PLAY_EVENT_FORM_DRAWER: "play-event-tour-form-drawer",
  PLAY_EVENT_FORM_BASICS: "play-event-tour-form-basics",
  PLAY_EVENT_FORM_SCHEDULE: "play-event-tour-form-schedule",
  PLAY_EVENT_FORM_REGISTRATION: "play-event-tour-form-registration",
  PLAY_EVENT_FORM_COURTS: "play-event-tour-form-courts",
  PLAY_EVENT_FORM_OPTIONS: "play-event-tour-form-options",
  PLAY_EVENT_FORM_SUBMIT: "play-event-tour-form-submit",
  PLAY_EVENT_SERIES_FORM_DRAWER: "play-event-series-tour-form-drawer",
  PLAY_EVENT_SERIES_FORM_SCHEDULE: "play-event-series-tour-form-schedule",
  PLAY_EVENT_SERIES_FORM_SOCIAL: "play-event-series-tour-form-social",
  PLAY_EVENT_SERIES_FORM_ROUNDS: "play-event-series-tour-form-rounds",
  PLAY_EVENT_SERIES_FORM_REGISTRATION: "play-event-series-tour-form-registration",
  PLAY_EVENT_SERIES_FORM_COURTS: "play-event-series-tour-form-courts",
  PLAY_EVENT_SERIES_FORM_GENERATION: "play-event-series-tour-form-generation",
  PLAY_EVENT_SERIES_FORM_SUBMIT: "play-event-series-tour-form-submit",
  ACADEMY_PROGRAMS_NEW: "academy-programs-tour-new",
  ACADEMY_PROGRAMS_LIST: "academy-programs-tour-list",
  PROGRAMS_FORM_DRAWER: "program-tour-form-drawer",
  PROGRAMS_FORM_DETAILS: "program-tour-form-details",
  PROGRAMS_FORM_PATHWAY: "program-tour-form-pathway",
  PROGRAMS_FORM_SKILLS: "program-tour-form-skills",
  PROGRAMS_FORM_SUBMIT: "program-tour-form-submit",
  ACADEMY_CALENDAR_GUIDE: "academy-calendar-tour-guide",
  ACADEMY_CALENDAR_VIEW: "academy-calendar-tour-view",
  ACADEMY_CALENDAR_CREATE: "academy-calendar-tour-create",
  ACADEMY_CALENDAR_FILTERS: "academy-calendar-tour-filters",
  ACADEMY_PAYMENTS_TABS: "academy-payments-tour-tabs",
  ACADEMY_PAYMENTS_BILLING: "academy-payments-tour-billing-report",
  ACADEMY_PAYMENTS_DASHBOARD: "academy-payments-tour-dashboard",
  ACADEMY_PAYMENTS_SETTINGS: "academy-payments-tour-settings",
  ACADEMY_PAYMENTS_TAX: "academy-payments-tour-tax",
  ACADEMY_PAYMENTS_DISCOUNTS: "academy-payments-tour-discounts",
  ACADEMY_PAYMENTS_PROMO_CODES: "academy-payments-tour-promo-codes",
  ACADEMY_PAYMENTS_ACCOUNTING: "academy-payments-tour-accounting",
  ACADEMY_SETTINGS_GUIDE: "academy-settings-tour-guide",
  ACADEMY_SETTINGS_TABS: "academy-settings-tour-tabs",
  ACADEMY_SETTINGS_NAME: "academy-settings-tour-name",
  ACADEMY_SETTINGS_AGE_GROUPS: "academy-settings-tour-age-groups",
  ACADEMY_SETTINGS_ADVANCED: "academy-settings-tour-advanced",
  STUDENTS_FILTERS: "academy-students-tour-filters",
  STUDENTS_LIST: "academy-students-tour-list",
  STUDENTS_ADD_STUDENT: "academy-students-tour-add-student",
  STUDENTS_MANUAL_FORM_DRAWER: "academy-students-tour-manual-form-drawer",
  STUDENTS_MANUAL_FORM_DETAILS: "academy-students-tour-manual-form-details",
  STUDENTS_MANUAL_FORM_SUBMIT: "academy-students-tour-manual-form-submit",
  STUDENTS_DATA_ACTIONS: "academy-students-tour-data-actions",
  STUDENTS_IMPORT_MODAL: "academy-students-tour-import-modal",
  STUDENT_DETAIL_TABS: "academy-student-detail-tour-tabs",
  STUDENT_DETAIL_BASIC_INFO: "academy-student-detail-tour-basic-info",
  STUDENT_DETAIL_CONTACT: "academy-student-detail-tour-contact",
  STUDENT_DETAIL_SIBLINGS: "academy-student-detail-tour-siblings",
  STUDENT_DETAIL_MEDICAL: "academy-student-detail-tour-medical",
  // Club management navigation
  CLUB_NAV_SECTIONS: "club-nav-sections",
  CLUB_NAV_GROUP: "club-nav-group",
  CLUB_NAV_COURT_HIRE: "club-nav-court-hire",
  CLUB_NAV_MEMBERS: "club-nav-members",
  CLUB_NAV_INVENTORY: "club-nav-inventory",
  CLUB_NAV_ORGANIZATION: "manage-organization",
  CLUB_NAV_CLUB_SETTINGS: "manage-club-settings",
  /** @deprecated Use CLUB_NAV_ORGANIZATION or CLUB_NAV_CLUB_SETTINGS */
  CLUB_NAV_SETTINGS: "manage-organization",
  // Club page tours
  CLUB_CALENDAR_GUIDE: "club-calendar-tour-guide",
  CLUB_CALENDAR_VIEW: "club-calendar-tour-view",
  CLUB_CALENDAR_FILTERS: "club-calendar-tour-filters",
  CLUB_COURTS_GUIDE: "club-courts-tour-guide",
  CLUB_COURTS_TABS: "club-courts-tour-tabs",
  CLUB_COURTS_NEW: "club-courts-tour-new",
  CLUB_COURTS_LIST: "club-courts-tour-list",
  CLUB_COURTS_FACILITY_SETTINGS: "club-courts-tour-facility-settings",
  CLUB_COURT_HIRE_GUIDE: "club-court-hire-tour-guide",
  CLUB_COURT_HIRE_TABS: "club-court-hire-tour-tabs",
  CLUB_COURT_HIRE_TAB_BOOKINGS: "club-court-hire-tour-tab-bookings",
  CLUB_COURT_HIRE_TAB_RATES: "club-court-hire-tour-tab-rates",
  CLUB_COURT_HIRE_TAB_SETTINGS: "club-court-hire-tour-tab-settings",
  CLUB_COURT_HIRE_BOOKINGS: "club-court-hire-tour-bookings",
  CLUB_COURT_HIRE_RATES: "club-court-hire-tour-rates",
  CLUB_COURT_HIRE_RATES_NEW: "club-court-hire-tour-rates-new",
  CLUB_COURT_HIRE_SETTINGS: "club-court-hire-tour-settings",
  COURT_HIRE_RATE_FORM_DRAWER: "court-hire-rate-tour-form-drawer",
  COURT_HIRE_RATE_FORM_DETAILS: "court-hire-rate-tour-form-details",
  COURT_HIRE_RATE_FORM_SUBMIT: "court-hire-rate-tour-form-submit",
  CLUB_MEMBERS_GUIDE: "club-members-tour-guide",
  CLUB_MEMBERS_TABS: "club-members-tour-tabs",
  CLUB_MEMBERS_TAB_MEMBERS: "club-members-tour-tab-members",
  CLUB_MEMBERS_TAB_MEMBERSHIPS: "club-members-tour-tab-memberships",
  CLUB_MEMBERS_TAB_TYPES: "club-members-tour-tab-types",
  CLUB_MEMBERS_TAB_ADDONS: "club-members-tour-tab-addons",
  CLUB_MEMBERS_TAB_SETTINGS: "club-members-tour-tab-settings",
  CLUB_MEMBERS_ROSTER: "club-members-tour-roster",
  CLUB_MEMBERS_TYPES: "club-members-tour-types",
  CLUB_MEMBERS_TYPES_NEW: "club-members-tour-types-new",
  CLUB_MEMBERS_SETTINGS: "club-members-tour-settings",
  MEMBERSHIP_TYPE_FORM_DRAWER: "membership-type-tour-form-drawer",
  MEMBERSHIP_TYPE_FORM_DETAILS: "membership-type-tour-form-details",
  MEMBERSHIP_TYPE_FORM_TERM: "membership-type-tour-form-term",
  MEMBERSHIP_TYPE_FORM_SEATS: "membership-type-tour-form-seats",
  MEMBERSHIP_TYPE_FORM_ELIGIBILITY: "membership-type-tour-form-eligibility",
  MEMBERSHIP_TYPE_FORM_VISIBILITY: "membership-type-tour-form-visibility",
  MEMBERSHIP_TYPE_FORM_SUBMIT: "membership-type-tour-form-submit",
  CLUB_INVENTORY_GUIDE: "club-inventory-tour-guide",
  CLUB_INVENTORY_TABS: "club-inventory-tour-tabs",
  CLUB_INVENTORY_TAB_ITEMS: "club-inventory-tour-tab-items",
  CLUB_INVENTORY_TAB_HIRES: "club-inventory-tour-tab-hires",
  CLUB_INVENTORY_ITEMS: "club-inventory-tour-items",
  CLUB_INVENTORY_ITEMS_NEW: "club-inventory-tour-items-new",
  CLUB_INVENTORY_HIRES: "club-inventory-tour-hires",
  INVENTORY_ITEM_FORM_DRAWER: "inventory-item-tour-form-drawer",
  INVENTORY_ITEM_FORM_DETAILS: "inventory-item-tour-form-details",
  INVENTORY_ITEM_FORM_OPTIONS: "inventory-item-tour-form-options",
  INVENTORY_ITEM_FORM_NOTES: "inventory-item-tour-form-notes",
  INVENTORY_ITEM_FORM_ACTIVE: "inventory-item-tour-form-active",
  INVENTORY_ITEM_FORM_SUBMIT: "inventory-item-tour-form-submit",
  // Professional upgrade (Starter → Professional+)
  PRO_UPGRADE_PAYMENTS: "manage-payments",
  PRO_UPGRADE_PROGRAMS: "manage-programs",
  PRO_UPGRADE_BOOKINGS: "manage-bookings",
  PRO_UPGRADE_ACADEMY_SETTINGS: "manage-academy-settings",
  /** @deprecated Professional upgrade tour uses PRO_UPGRADE_DASHBOARD_MODE */
  PRO_UPGRADE_ACCOUNT_MENU: "account-menu",
  PRO_UPGRADE_DASHBOARD_MODE: "dashboard-mode-switch",
  PRO_UPGRADE_PLAY_EVENTS: "manage-play",
  // Enterprise upgrade (Professional → Enterprise)
  ENT_UPGRADE_PAYMENTS: "manage-payments",
  ENT_UPGRADE_ACADEMY_SETTINGS: "manage-academy-settings",
  ENT_UPGRADE_ACCOUNT_MENU: "account-menu",
};

/** Tour step selector ids for the post-upgrade Professional feature tour */
export const PROFESSIONAL_UPGRADE_TOUR_STEP_IDS = {
  PAYMENTS: TOUR_STEP_IDS.PRO_UPGRADE_PAYMENTS,
  PROGRAMS: TOUR_STEP_IDS.PRO_UPGRADE_PROGRAMS,
  BOOKINGS: TOUR_STEP_IDS.PRO_UPGRADE_BOOKINGS,
  ACADEMY_SETTINGS: TOUR_STEP_IDS.PRO_UPGRADE_ACADEMY_SETTINGS,
  DASHBOARD_MODE_SWITCH: TOUR_STEP_IDS.PRO_UPGRADE_DASHBOARD_MODE,
  PLAY_EVENTS: TOUR_STEP_IDS.PRO_UPGRADE_PLAY_EVENTS,
} as const;

export const ENTERPRISE_UPGRADE_TOUR_STEP_IDS = {
  PAYMENTS: TOUR_STEP_IDS.ENT_UPGRADE_PAYMENTS,
  ACADEMY_SETTINGS: TOUR_STEP_IDS.ENT_UPGRADE_ACADEMY_SETTINGS,
  ACCOUNT_MENU: TOUR_STEP_IDS.ENT_UPGRADE_ACCOUNT_MENU,
} as const;

/** Tour step selector ids scoped to the camp management page */
export const CAMP_MANAGEMENT_TOUR_STEP_IDS = {
  GUIDE: TOUR_STEP_IDS.CAMPS_GUIDE,
  NEW_CAMP: TOUR_STEP_IDS.CAMPS_NEW_CAMP,
  LIST_TABS: TOUR_STEP_IDS.CAMPS_LIST_TABS,
  FILTERS: TOUR_STEP_IDS.CAMPS_FILTERS,
} as const;

export const CAMP_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.CAMPS_FORM_DRAWER,
  DETAILS: TOUR_STEP_IDS.CAMPS_FORM_DETAILS,
  SCHEDULE: TOUR_STEP_IDS.CAMPS_FORM_SCHEDULE,
  TIMES: TOUR_STEP_IDS.CAMPS_FORM_TIMES,
  PRICING: TOUR_STEP_IDS.CAMPS_FORM_PRICING,
  RESOURCES: TOUR_STEP_IDS.CAMPS_FORM_RESOURCES,
  SUBMIT: TOUR_STEP_IDS.CAMPS_FORM_SUBMIT,
} as const;

export const PROGRAM_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.PROGRAMS_FORM_DRAWER,
  DETAILS: TOUR_STEP_IDS.PROGRAMS_FORM_DETAILS,
  PATHWAY: TOUR_STEP_IDS.PROGRAMS_FORM_PATHWAY,
  SKILLS: TOUR_STEP_IDS.PROGRAMS_FORM_SKILLS,
  SUBMIT: TOUR_STEP_IDS.PROGRAMS_FORM_SUBMIT,
} as const;

export const BOOKINGS_MANAGEMENT_TOUR_STEP_IDS = {
  BOOKINGS_TABS: TOUR_STEP_IDS.BOOKINGS_TABS,
  BOOKINGS_FILTERS: TOUR_STEP_IDS.BOOKINGS_FILTERS,
  BOOKINGS_LIST: TOUR_STEP_IDS.BOOKINGS_LIST,
  WAITLIST: TOUR_STEP_IDS.BOOKINGS_WAITLIST,
  EOI_SCOPE: TOUR_STEP_IDS.BOOKINGS_EOI_SCOPE,
  EOI_LIST: TOUR_STEP_IDS.BOOKINGS_EOI_LIST,
  PRIVATE_INTRO: TOUR_STEP_IDS.BOOKINGS_PRIVATE_INTRO,
  PRIVATE_LIST: TOUR_STEP_IDS.BOOKINGS_PRIVATE_LIST,
} as const;

export const CAMP_BULK_WIZARD_TOUR_STEP_IDS = {
  contentId: (step: number) => `camp-bulk-wizard-tour-step-${step}`,
  SCHEDULE_SPAN: 'camp-bulk-wizard-tour-schedule-span',
  SCHEDULE_TIMES_DAYS: 'camp-bulk-wizard-tour-schedule-times-days',
  DEFAULTS_SHARED: 'camp-bulk-wizard-tour-defaults-shared',
  DEFAULTS_OPTIONAL: 'camp-bulk-wizard-tour-defaults-optional',
} as const;

/** Tour step selector ids scoped to the term management page */
export const ACADEMY_PAGE_TOUR_STEP_IDS = {
  PROFILE_GUIDE: TOUR_STEP_IDS.ACADEMY_PROFILE_GUIDE,
  PROFILE_TABS: TOUR_STEP_IDS.ACADEMY_PROFILE_TABS,
  PROFILE_FORM: TOUR_STEP_IDS.ACADEMY_PROFILE_FORM,
  PUBLIC_SITE_GUIDE: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_GUIDE,
  PUBLIC_SITE_URL: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_URL,
  PUBLIC_SITE_BRANDING: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_BRANDING,
  PUBLIC_SITE_MEDIA: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_MEDIA,
  PUBLIC_SITE_DIRECTORY: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_DIRECTORY,
  PUBLIC_SITE_SAVE: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_SAVE,
  SPORTS_GUIDE: TOUR_STEP_IDS.ACADEMY_SPORTS_GUIDE,
  SPORTS_LIST: TOUR_STEP_IDS.ACADEMY_SPORTS_LIST,
  SPORTS_SAVE: TOUR_STEP_IDS.ACADEMY_SPORTS_SAVE,
  COURTS_TABS: TOUR_STEP_IDS.ACADEMY_COURTS_TABS,
  LOCATIONS_NEW: TOUR_STEP_IDS.ACADEMY_LOCATIONS_NEW,
  LOCATIONS_LIST: TOUR_STEP_IDS.ACADEMY_LOCATIONS_LIST,
  COACHES_TABS: TOUR_STEP_IDS.ACADEMY_COACHES_TABS,
  COACHES_NEW: TOUR_STEP_IDS.ACADEMY_COACHES_NEW,
  COACHES_LIST: TOUR_STEP_IDS.ACADEMY_COACHES_LIST,
  PROGRAMS_NEW: TOUR_STEP_IDS.ACADEMY_PROGRAMS_NEW,
  PROGRAMS_LIST: TOUR_STEP_IDS.ACADEMY_PROGRAMS_LIST,
  CALENDAR_GUIDE: TOUR_STEP_IDS.ACADEMY_CALENDAR_GUIDE,
  CALENDAR_VIEW: TOUR_STEP_IDS.ACADEMY_CALENDAR_VIEW,
  CALENDAR_CREATE: TOUR_STEP_IDS.ACADEMY_CALENDAR_CREATE,
  CALENDAR_FILTERS: TOUR_STEP_IDS.ACADEMY_CALENDAR_FILTERS,
  PAYMENTS_TABS: TOUR_STEP_IDS.ACADEMY_PAYMENTS_TABS,
  PAYMENTS_SETTINGS: TOUR_STEP_IDS.ACADEMY_PAYMENTS_SETTINGS,
} as const;

export const ACADEMY_SETTINGS_TOUR_STEP_IDS = {
  GUIDE: TOUR_STEP_IDS.ACADEMY_SETTINGS_GUIDE,
  TABS: TOUR_STEP_IDS.ACADEMY_SETTINGS_TABS,
  NAME: TOUR_STEP_IDS.ACADEMY_SETTINGS_NAME,
  AGE_GROUPS: TOUR_STEP_IDS.ACADEMY_SETTINGS_AGE_GROUPS,
  ADVANCED: TOUR_STEP_IDS.ACADEMY_SETTINGS_ADVANCED,
} as const;

export const ORGANIZATION_SETTINGS_TOUR_STEP_IDS = {
  GUIDE: TOUR_STEP_IDS.ORGANIZATION_SETTINGS_GUIDE,
  TABS: TOUR_STEP_IDS.ACADEMY_PROFILE_TABS,
  TAB_BASIC: TOUR_STEP_IDS.ORGANIZATION_SETTINGS_TAB_BASIC,
  TAB_PUBLIC_SITE: TOUR_STEP_IDS.ORGANIZATION_SETTINGS_TAB_PUBLIC_SITE,
  TAB_SPORTS: TOUR_STEP_IDS.ORGANIZATION_SETTINGS_TAB_SPORTS,
  TAB_PLAYER_RATINGS: TOUR_STEP_IDS.ORGANIZATION_SETTINGS_TAB_PLAYER_RATINGS,
  BASIC: TOUR_STEP_IDS.ACADEMY_PROFILE_FORM,
  PUBLIC_SITE_URL: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_URL,
  PUBLIC_SITE_DIRECTORY: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_DIRECTORY,
  PUBLIC_SITE_BRANDING: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_BRANDING,
  PUBLIC_SITE_MEDIA: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_MEDIA,
  PUBLIC_SITE_SAVE: TOUR_STEP_IDS.ACADEMY_PUBLIC_SITE_SAVE,
  SPORTS_LIST: TOUR_STEP_IDS.ACADEMY_SPORTS_LIST,
  PLAYER_RATINGS_FORM: TOUR_STEP_IDS.ORGANIZATION_PLAYER_RATINGS_FORM,
} as const;

export const PAYMENTS_MANAGEMENT_TOUR_STEP_IDS = {
  TABS: TOUR_STEP_IDS.ACADEMY_PAYMENTS_TABS,
  BILLING_REPORT: TOUR_STEP_IDS.ACADEMY_PAYMENTS_BILLING,
  DASHBOARD: TOUR_STEP_IDS.ACADEMY_PAYMENTS_DASHBOARD,
  SETTINGS: TOUR_STEP_IDS.ACADEMY_PAYMENTS_SETTINGS,
  TAX: TOUR_STEP_IDS.ACADEMY_PAYMENTS_TAX,
  DISCOUNTS: TOUR_STEP_IDS.ACADEMY_PAYMENTS_DISCOUNTS,
  PROMO_CODES: TOUR_STEP_IDS.ACADEMY_PAYMENTS_PROMO_CODES,
  ACCOUNTING: TOUR_STEP_IDS.ACADEMY_PAYMENTS_ACCOUNTING,
} as const;

export const STUDENTS_MANAGEMENT_TOUR_STEP_IDS = {
  FILTERS: TOUR_STEP_IDS.STUDENTS_FILTERS,
  LIST: TOUR_STEP_IDS.STUDENTS_LIST,
  ADD_STUDENT: TOUR_STEP_IDS.STUDENTS_ADD_STUDENT,
  MANUAL_FORM_DRAWER: TOUR_STEP_IDS.STUDENTS_MANUAL_FORM_DRAWER,
  MANUAL_FORM_DETAILS: TOUR_STEP_IDS.STUDENTS_MANUAL_FORM_DETAILS,
  MANUAL_FORM_SUBMIT: TOUR_STEP_IDS.STUDENTS_MANUAL_FORM_SUBMIT,
  DATA_ACTIONS: TOUR_STEP_IDS.STUDENTS_DATA_ACTIONS,
  IMPORT_MODAL: TOUR_STEP_IDS.STUDENTS_IMPORT_MODAL,
  DETAIL_TABS: TOUR_STEP_IDS.STUDENT_DETAIL_TABS,
  DETAIL_BASIC_INFO: TOUR_STEP_IDS.STUDENT_DETAIL_BASIC_INFO,
  DETAIL_CONTACT: TOUR_STEP_IDS.STUDENT_DETAIL_CONTACT,
  DETAIL_SIBLINGS: TOUR_STEP_IDS.STUDENT_DETAIL_SIBLINGS,
  DETAIL_MEDICAL: TOUR_STEP_IDS.STUDENT_DETAIL_MEDICAL,
} as const;

export const TERM_MANAGEMENT_TOUR_STEP_IDS = {
  GUIDE: TOUR_STEP_IDS.TERMS_GUIDE,
  NEW_TERM: TOUR_STEP_IDS.TERMS_NEW_TERM,
  LIST_TABS: TOUR_STEP_IDS.TERMS_LIST_TABS,
  FILTERS: TOUR_STEP_IDS.TERMS_FILTERS,
  FORM_DRAWER: TOUR_STEP_IDS.TERMS_FORM_DRAWER,
  FORM_DETAILS: TOUR_STEP_IDS.TERMS_FORM_DETAILS,
  FORM_SCHEDULE: TOUR_STEP_IDS.TERMS_FORM_SCHEDULE,
  FORM_COPY: TOUR_STEP_IDS.TERMS_FORM_COPY,
  FORM_SUBMIT: TOUR_STEP_IDS.TERMS_FORM_SUBMIT,
  MANAGE_HEADER: TOUR_STEP_IDS.TERMS_MANAGE_HEADER,
  MANAGE_ADD_LESSON: TOUR_STEP_IDS.TERMS_MANAGE_ADD_LESSON,
  MANAGE_VIEWS: TOUR_STEP_IDS.TERMS_MANAGE_VIEWS,
  MANAGE_LESSONS: TOUR_STEP_IDS.TERMS_MANAGE_LESSONS,
  LESSON_FORM_DETAILS: TOUR_STEP_IDS.TERMS_LESSON_FORM_DETAILS,
  LESSON_FORM_SCHEDULE: TOUR_STEP_IDS.TERMS_LESSON_FORM_SCHEDULE,
  LESSON_FORM_PRICING: TOUR_STEP_IDS.TERMS_LESSON_FORM_PRICING,
  LESSON_FORM_SUBMIT: TOUR_STEP_IDS.TERMS_LESSON_FORM_SUBMIT,
} as const;

export const LESSON_SESSION_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.LESSON_SESSION_DRAWER,
  OVERVIEW: TOUR_STEP_IDS.LESSON_SESSION_OVERVIEW,
  COACHES: TOUR_STEP_IDS.LESSON_SESSION_COACHES,
  STUDENTS: TOUR_STEP_IDS.LESSON_SESSION_STUDENTS,
  ACTIONS: TOUR_STEP_IDS.LESSON_SESSION_ACTIONS,
} as const;

export const COACH_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.COACH_FORM_DRAWER,
  CONTACT: TOUR_STEP_IDS.COACH_FORM_CONTACT,
  COMPENSATION: TOUR_STEP_IDS.COACH_FORM_COMPENSATION,
  PROFILE: TOUR_STEP_IDS.COACH_FORM_PROFILE,
  SUBMIT: TOUR_STEP_IDS.COACH_FORM_SUBMIT,
} as const;

export const PLAY_EVENT_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.PLAY_EVENT_FORM_DRAWER,
  BASICS: TOUR_STEP_IDS.PLAY_EVENT_FORM_BASICS,
  SCHEDULE: TOUR_STEP_IDS.PLAY_EVENT_FORM_SCHEDULE,
  REGISTRATION: TOUR_STEP_IDS.PLAY_EVENT_FORM_REGISTRATION,
  COURTS: TOUR_STEP_IDS.PLAY_EVENT_FORM_COURTS,
  OPTIONS: TOUR_STEP_IDS.PLAY_EVENT_FORM_OPTIONS,
  SUBMIT: TOUR_STEP_IDS.PLAY_EVENT_FORM_SUBMIT,
} as const;

export const PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_DRAWER,
  SCHEDULE: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_SCHEDULE,
  SOCIAL: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_SOCIAL,
  ROUNDS: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_ROUNDS,
  REGISTRATION: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_REGISTRATION,
  COURTS: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_COURTS,
  GENERATION: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_GENERATION,
  SUBMIT: TOUR_STEP_IDS.PLAY_EVENT_SERIES_FORM_SUBMIT,
} as const;

export const CLUB_PAGE_TOUR_STEP_IDS = {
  CALENDAR_GUIDE: TOUR_STEP_IDS.CLUB_CALENDAR_GUIDE,
  CALENDAR_VIEW: TOUR_STEP_IDS.CLUB_CALENDAR_VIEW,
  CALENDAR_FILTERS: TOUR_STEP_IDS.CLUB_CALENDAR_FILTERS,
  COURTS_GUIDE: TOUR_STEP_IDS.CLUB_COURTS_GUIDE,
  COURTS_TABS: TOUR_STEP_IDS.CLUB_COURTS_TABS,
  COURTS_NEW: TOUR_STEP_IDS.CLUB_COURTS_NEW,
  COURTS_LIST: TOUR_STEP_IDS.CLUB_COURTS_LIST,
  COURTS_FACILITY_SETTINGS: TOUR_STEP_IDS.CLUB_COURTS_FACILITY_SETTINGS,
  COURT_HIRE_GUIDE: TOUR_STEP_IDS.CLUB_COURT_HIRE_GUIDE,
  COURT_HIRE_TABS: TOUR_STEP_IDS.CLUB_COURT_HIRE_TABS,
  COURT_HIRE_TAB_BOOKINGS: TOUR_STEP_IDS.CLUB_COURT_HIRE_TAB_BOOKINGS,
  COURT_HIRE_TAB_RATES: TOUR_STEP_IDS.CLUB_COURT_HIRE_TAB_RATES,
  COURT_HIRE_TAB_SETTINGS: TOUR_STEP_IDS.CLUB_COURT_HIRE_TAB_SETTINGS,
  COURT_HIRE_BOOKINGS: TOUR_STEP_IDS.CLUB_COURT_HIRE_BOOKINGS,
  COURT_HIRE_RATES: TOUR_STEP_IDS.CLUB_COURT_HIRE_RATES,
  COURT_HIRE_RATES_NEW: TOUR_STEP_IDS.CLUB_COURT_HIRE_RATES_NEW,
  COURT_HIRE_SETTINGS: TOUR_STEP_IDS.CLUB_COURT_HIRE_SETTINGS,
  MEMBERS_GUIDE: TOUR_STEP_IDS.CLUB_MEMBERS_GUIDE,
  MEMBERS_TABS: TOUR_STEP_IDS.CLUB_MEMBERS_TABS,
  MEMBERS_TAB_MEMBERS: TOUR_STEP_IDS.CLUB_MEMBERS_TAB_MEMBERS,
  MEMBERS_TAB_MEMBERSHIPS: TOUR_STEP_IDS.CLUB_MEMBERS_TAB_MEMBERSHIPS,
  MEMBERS_TAB_TYPES: TOUR_STEP_IDS.CLUB_MEMBERS_TAB_TYPES,
  MEMBERS_TAB_ADDONS: TOUR_STEP_IDS.CLUB_MEMBERS_TAB_ADDONS,
  MEMBERS_TAB_SETTINGS: TOUR_STEP_IDS.CLUB_MEMBERS_TAB_SETTINGS,
  MEMBERS_ROSTER: TOUR_STEP_IDS.CLUB_MEMBERS_ROSTER,
  MEMBERS_TYPES: TOUR_STEP_IDS.CLUB_MEMBERS_TYPES,
  MEMBERS_TYPES_NEW: TOUR_STEP_IDS.CLUB_MEMBERS_TYPES_NEW,
  MEMBERS_SETTINGS: TOUR_STEP_IDS.CLUB_MEMBERS_SETTINGS,
  INVENTORY_GUIDE: TOUR_STEP_IDS.CLUB_INVENTORY_GUIDE,
  INVENTORY_TABS: TOUR_STEP_IDS.CLUB_INVENTORY_TABS,
  INVENTORY_TAB_ITEMS: TOUR_STEP_IDS.CLUB_INVENTORY_TAB_ITEMS,
  INVENTORY_TAB_HIRES: TOUR_STEP_IDS.CLUB_INVENTORY_TAB_HIRES,
  INVENTORY_ITEMS: TOUR_STEP_IDS.CLUB_INVENTORY_ITEMS,
  INVENTORY_ITEMS_NEW: TOUR_STEP_IDS.CLUB_INVENTORY_ITEMS_NEW,
  INVENTORY_HIRES: TOUR_STEP_IDS.CLUB_INVENTORY_HIRES,
} as const;

export const COURT_HIRE_RATE_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.COURT_HIRE_RATE_FORM_DRAWER,
  DETAILS: TOUR_STEP_IDS.COURT_HIRE_RATE_FORM_DETAILS,
  SUBMIT: TOUR_STEP_IDS.COURT_HIRE_RATE_FORM_SUBMIT,
} as const;

export const MEMBERSHIP_TYPE_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_DRAWER,
  DETAILS: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_DETAILS,
  TERM: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_TERM,
  SEATS: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_SEATS,
  ELIGIBILITY: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_ELIGIBILITY,
  VISIBILITY: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_VISIBILITY,
  SUBMIT: TOUR_STEP_IDS.MEMBERSHIP_TYPE_FORM_SUBMIT,
} as const;

export const INVENTORY_ITEM_CREATE_TOUR_STEP_IDS = {
  DRAWER: TOUR_STEP_IDS.INVENTORY_ITEM_FORM_DRAWER,
  DETAILS: TOUR_STEP_IDS.INVENTORY_ITEM_FORM_DETAILS,
  OPTIONS: TOUR_STEP_IDS.INVENTORY_ITEM_FORM_OPTIONS,
  NOTES: TOUR_STEP_IDS.INVENTORY_ITEM_FORM_NOTES,
  ACTIVE: TOUR_STEP_IDS.INVENTORY_ITEM_FORM_ACTIVE,
  SUBMIT: TOUR_STEP_IDS.INVENTORY_ITEM_FORM_SUBMIT,
} as const;

/** Tour step selector ids for the club management sidenav (post-upsell) */
export const CLUB_MANAGEMENT_TOUR_STEP_IDS = {
  NAV_SECTIONS: TOUR_STEP_IDS.CLUB_NAV_SECTIONS,
  CLUB_GROUP: TOUR_STEP_IDS.CLUB_NAV_GROUP,
  COURT_HIRE: TOUR_STEP_IDS.CLUB_NAV_COURT_HIRE,
  MEMBERS: TOUR_STEP_IDS.CLUB_NAV_MEMBERS,
  INVENTORY: TOUR_STEP_IDS.CLUB_NAV_INVENTORY,
  ORGANIZATION: TOUR_STEP_IDS.CLUB_NAV_ORGANIZATION,
  CLUB_SETTINGS: TOUR_STEP_IDS.CLUB_NAV_CLUB_SETTINGS,
  ACADEMY_SETTINGS: TOUR_STEP_IDS.MANAGE_ACADEMY_SETTINGS,
  /** @deprecated Use ORGANIZATION */
  SETTINGS: TOUR_STEP_IDS.CLUB_NAV_ORGANIZATION,
} as const;

/** Tour IDs for localStorage keys - used with getTourStorageKey */
export const TOUR_IDS = {
  ACADEMY_OWNER_DASHBOARD: "academy-owner-dashboard",
  STUDENT_DASHBOARD: "student-dashboard",
  ADMIN_DASHBOARD: "admin-dashboard",
} as const;

/**
 * Get the localStorage key for tour completion status.
 * Scoped by userId so each user sees the tour on their first visit, even on shared devices.
 */
/** Centered tour steps use an empty selector and do not highlight page elements. */
export const TOUR_CENTERED_STEP_SELECTOR = '';

/** Drawer enter (300ms) + animation buffer (24ms) + default target poll (2500ms). */
export const TOUR_DRAWER_TARGET_POLL_TIMEOUT_MS = 2824;

export function getTourStorageKey(
  tourId: string,
  userId?: string | null
): string {
  const userSuffix = userId ? `-${userId}` : "";
  return `courtsync-tour-${tourId}${userSuffix}-completed`;
}
